/* Zenvixo: lightweight scroll reveal. No dependencies. */
(function () {
  var root = document.documentElement;
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  root.classList.add('js-zv');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  function scan(scope) {
    (scope || document).querySelectorAll('[data-zv-reveal]:not(.is-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight) { el.classList.add('is-in'); } else { io.observe(el); }
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { scan(); }); } else { scan(); }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
